export default {
	AF: 0.23186502811419166,
	AL: 0.3948703538219803,
	DZ: 0.24072349569948903,
	AO: 0.38109013834388333,
	AG: 0.6268154150709515,
	AR: 0.27947660777976496,
	AM: 0.4287365276428688,
	AW: 0.6360227746146369,
	AU: 1.072473236646664,
	AT: 0.920353592134559,
	AZ: 0.2370588235294118,
	BS: 1.01,
	BH: 0.5066917801859638,
	BD: 0.40683552988281385,
	BB: 0.9655,
	BY: 0.2175349115880356,
	BE: 0.895002535105703,
	BZ: 0.5625309615847557,
	BJ: 0.34891918681789935,
	BT: 0.3135168068178288,
	BO: 0.507922897216705,
	BA: 0.38846994150398195,
	BW: 0.4284618773918767,
	BR: 0.43963641539744186,
	BN: 0.34035025806818375,
	BG: 0.38275084554678696,
	BF: 0.3407561749731541,
	BI: 0.4472911052181509,
	KH: 0.35878239166873416,
	CM: 0.3687150786546519,
	CA: 0.9583864776912899,
	CV: 0.45103585657370515,
	CF: 0.5727450060372177,
	TD: 0.3464961602472689,
	CL: 0.5083554042123849,
	CN: 0.5524315154561448,
	CO: 0.36151628126493784,
	KM: 0.48281803423982544,
	CG: 0.3106565390787691,
	CD: 0.5604730276664935,
	CR: 0.6298240289403616,
	CI: 0.3697904857317694,
	HR: 0.5097913696278407,
	CY: 0.6580252628794392,
	CZ: 0.5920218559720015,
	DK: 1.0761640913198713,
	DJ: 0.5596323075005203,
	DM: 0.700079554494829,
	DO: 0.4048651603498542,
	EC: 0.518,
	EG: 0.24158054842398222,
	SV: 0.484,
	GQ: 0.41537094256597284,
	ER: 0.8045998390800323,
	EE: 0.6470030641712409,
	ET: 0.24302421489058815,
	FJ: 0.5808890377530025,
	FI: 0.993100103608668,
	FR: 0.8630381588519278,
	GA: 0.4019417966904677,
	GM: 0.2671669793621013,
	GE: 0.3125581395348837,
	DE: 0.8575270594978287,
	GH: 0.24970634774122027,
	GR: 0.6414919648171417,
	GD: 0.6845386764352186,
	GT: 0.5683353983503822,
	GN: 0.47983179142136245,
	GW: 0.4134200869151393,
	GY: 0.4851339039971107,
	HT: 0.4000079772364515,
	HN: 0.5054194947087595,
	HK: 0.7608763148594353,
	HU: 0.4135584947439851,
	IS: 1.145503833940051,
	IN: 0.25353929422807386,
	ID: 0.3080160955980978,
	IR: 0.6025113475177305,
	IQ: 0.25869315068493154,
	IE: 0.8927980953640633,
	IL: 1.21650792860831,
	IT: 0.7858827678945396,
	JM: 0.5215474662634414,
	JP: 0.7841834700903373,
	JO: 0.45980253878702404,
	KZ: 0.24343573360970613,
	KE: 0.49357605461228776,
	KI: 0.7920490801938507,
	KR: 0.6777497371131507,
	KW: 0.4213201144147436,
	KG: 0.23416543136051182,
	LA: 0.25613194008235035,
	LV: 0.5698476732138528,
	LB: 0.6287402511566424,
	LS: 0.4127444369521241,
	LR: 0.003072406584048588,
	LY: 0.19849785407725323,
	LT: 0.5180433392853206,
	LU: 0.9953045433503076,
	MO: 0.6978564044801585,
	MK: 0.36315010912042434,
	MG: 0.26328679540741684,
	MW: 0.3037195345988977,
	MY: 0.3417526384442073,
	MV: 0.6708737864077671,
	ML: 0.36497299809099454,
	MT: 0.639287525075502,
	MH: 1.012,
	MR: 2.9669868276619105,
	MU: 0.37181247956414376,
	MX: 0.4673749689369943,
	FM: 1.02,
	MD: 0.4392216367084019,
	MN: 0.29602781010962886,
	ME: 0.4199457707823557,
	MA: 0.3596315166486542,
	MZ: 0.38873922648803094,
	MM: 0.18154490817032354,
	NA: 0.5045822102425876,
	NR: 0.6973313464983525,
	NP: 0.32155474194265204,
	NL: 0.8707536979476667,
	NZ: 1.0416065093100975,
	NI: 0.35145538352673844,
	NE: 0.36709524674474364,
	NG: 0.32419362603504714,
	NO: 1.0107385126359978,
	OM: 0.37655002272284616,
	PK: 0.18543922040063113,
	PW: 1.08,
	PA: 0.608,
	PG: 0.6444353082264372,
	PY: 0.3833944046985296,
	PE: 0.43146603098927294,
	PH: 0.3641454719591359,
	PL: 0.409651956023309,
	PT: 0.6701496814584573,
	PR: 0.78,
	QA: 0.5174402636638286,
	RO: 0.42854913153024593,
	RU: 0.24624205100502616,
	RW: 0.31840314650934115,
	KN: 0.6020240143568112,
	LC: 0.7389317496438549,
	VC: 0.6279254777894951,
	WS: 0.7727559734958528,
	SM: 0.7439984128033861,
	ST: 617.4219743446737,
	SA: 0.39027251097974663,
	SN: 0.3734418288232951,
	RS: 0.402873750365336,
	SC: 0.5383066952450176,
	SL: 0.28947832152616787,
	SG: 0.6221000298519564,
	SK: 0.5268610982518793,
	SI: 0.6602297026210788,
	SB: 1.0422006785486821,
	SO: 0.0006051282051282051,
	ZA: 0.4582499183358716,
	SS: 0.28877629356671275,
	ES: 0.7065229371955118,
	LK: 0.18692878905234078,
	SD: 0.062053691275167785,
	SR: 0.16062413951353832,
	SZ: 0.3858490566037736,
	SE: 0.9363857287412681,
	CH: 1.3015235544672596,
	TW: 0.47854403712817495,
	TJ: 0.1865571396380961,
	TZ: 0.34752844827586205,
	TH: 0.36284981204129124,
	TL: 0.499,
	TG: 0.3667406984740064,
	TO: 0.75859009285762,
	TT: 0.4970071812887941,
	TN: 0.2750891492613347,
	TR: 0.1423994063880738,
	TM: 0.4491428571428572,
	TV: 0.9934174904126263,
	UG: 0.32558337657217834,
	UA: 0.37052369121525364,
	AE: 0.5586561759821405,
	GB: 0.922463986131231,
	US: 1,
	UY: 0.6182958109759483,
	UZ: 0.16501014606867345,
	VU: 1.1032688762753151,
	VE: 179792902.27471304,
	VN: 0.35043357066018754,
	YE: 1.0418899196366216,
	ZM: 0.27572362135778655,
	ZW: 0.00663975155279503,
}
